import type { ProvisionUserRequest, User } from '@pay-plan/shared';
import { apiRequest } from './client.js';

export async function listUsers(): Promise<User[]> {
  const res = await apiRequest<{ users: User[] }>('GET', '/users');
  return res.users;
}

export async function getUser(userId: string): Promise<User> {
  const res = await apiRequest<{ user: User }>('GET', `/users/${userId}`);
  return res.user;
}

export async function provisionCurrentUser(profile: ProvisionUserRequest): Promise<User> {
  const res = await apiRequest<{ user: User }>('POST', '/users/me', profile);
  return res.user;
}
